import {
  Drawer,
  Container,
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';
import { useAuthUser } from 'features/auth/hooks/useAuthUser';
import { FC, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import requiredLoginImg from 'assets/images/login-required.png';
import { useTypedDispatch, useTypedSelector } from 'shared/redux/store';
import { authSlice, selectToken } from 'features/auth/slice';
import dayjs from 'dayjs';
import { SEARCH_PARAM } from 'shared/constants/common';

export type RequireAuthProps = {
  onlyPublic?: boolean;
  children: JSX.Element;
};

const RequireAuth: FC<RequireAuthProps> = ({ children, onlyPublic }) => {
  const dispatch = useTypedDispatch();
  const [cookies, setCookie, removeCookie] = useCookies([SEARCH_PARAM.TOKEN]);
  const [searchParams] = useSearchParams();
  const tokenParam = searchParams.get(SEARCH_PARAM.TOKEN);
  const location = useLocation();
  const token = useTypedSelector(selectToken);

  const user = useAuthUser();
  const { origin, pathname, search } = window.location;

  useEffect(() => {
    if (!token) {
      if (tokenParam) {
        removeCookie(SEARCH_PARAM.TOKEN, {
          domain: process.env.REACT_APP_DOMAIN,
        });

        setCookie(SEARCH_PARAM.TOKEN, tokenParam, {
          expires: dayjs().add(3, 'month').toDate(),
          domain: process.env.REACT_APP_DOMAIN,
          sameSite: 'none',
          secure: true,
        });
        dispatch(authSlice.actions.updateAccessToken(tokenParam));
        // searchParams.delete(SEARCH_PARAM.TOKEN);
        // navigate(`${location.pathname}?${searchParams.toString()}`, {
        //   replace: true,
        // });
      } else if (cookies.token) {
        dispatch(authSlice.actions.updateAccessToken(cookies.token));
      } else {
        console.log('RequireAuth no tokenParam, cookies.token resetAuth');
        dispatch(authSlice.actions.resetAuth());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, cookies.token, tokenParam]);

  const handleLogin = () => {
    let redirectUrl = `${origin}${
      ['/', '/cart'].includes(pathname) ? pathname : '/'
    }${search}`;

    if (window.encodeURIComponent)
      redirectUrl = window.encodeURIComponent(redirectUrl);

    window.open(
      `${process.env.REACT_APP_AUTHENTICATE}?source=b2b&redirect_url=${redirectUrl}`,
      '_self'
    );
  };

  if (onlyPublic) {
    return user ? (
      <Navigate to='/' state={{ from: location }} replace />
    ) : (
      children
    );
  }

  return (
    <>
      {children}
      {!user && (
        <Drawer anchor='bottom' sx={{ position: 'absolute' }} open={true}>
          <Container maxWidth='sm' disableGutters>
            <Card elevation={0} sx={{ width: '100%', textAlign: 'center' }}>
              <CardMedia
                component='img'
                alt='Required login'
                image={requiredLoginImg}
                sx={{
                  maxWidth: 256,
                  marginTop: 2.25,
                  marginBottom: 0.5,
                  marginX: 'auto',
                }}
              />
              <CardContent>
                <Typography variant='subtitle1' gutterBottom>
                  Đăng nhập để tiếp tục
                </Typography>
                <Typography
                  variant='body2'
                  color='grey.600'
                  marginBottom={3}
                  marginX='auto'
                  maxWidth={310}
                >
                  Cảm ơn bạn đã sử dụng dịch vụ của chúng tôi. Vui lòng đăng
                  nhập để tiếp tục đặt hàng nha.
                </Typography>
                <Button
                  fullWidth
                  size='large'
                  variant='contained'
                  onClick={handleLogin}
                >
                  Đăng nhập ngay
                </Button>
              </CardContent>
            </Card>
          </Container>
        </Drawer>
      )}
    </>
  );
};

export default RequireAuth;
